export var getDeliveryCouponId = function (gameId, deliveryId) {
    return gameId + "-" + deliveryId;
};
